import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'
import { CreateEvent } from 'Pages/Frontend/Components/Events/Events'

AxiosInterceptor()

type UpdateEvent = {
  title: string
  description: string
  eventType: string
  location: string
  startDate: Date
  endDate: Date
  isRecurring: boolean
  frequency?: 'daily' | 'weekly' | 'monthly' | 'yearly'
  // roles: string[]
  // fileUrl: {
  //   filePath: string
  //   fileName: string
  //   mimeType: string
  //   sizeInBytes: number
  //   uploaderEmail: string
  // }
}

const eventService = {
  index: async () => {
    return await axios.get('/Company_Events')
  },
  createEvent: async (data: CreateEvent) => {
    return await axios.post('/Company_Events', data)
  },

  updateEvent: async (eventDisplayId: string, data: UpdateEvent) => {
    return await axios.put(`/Company_Events/${eventDisplayId}`, data)
  },

  deleteEvent: async (eventDisplayId: string) => {
    return await axios.delete(`/Company_Events/${eventDisplayId}`)
  },
}

export default eventService
